import Marquee from 'react-fast-marquee';
import PromotionLink from '@/components/promotion-link';
import {
  buildPromotion,
  getPromotionName,
  PROMOTION_SECTIONS,
} from '@/utils/gtm/promotions';

const Alerts = ({ data, locale, isMobile }) => {
  const active = isMobile ? 'mobile-active' : 'active';
  const activeData = data?.value?.filter((e) => e[active]);

  if (!activeData?.length) return null;

  const activeDataToShow = [
    ...activeData,
    ...activeData,
    ...activeData,
    ...activeData,
  ];

  const ItemsRow = ({ justify }) => (
    <div className={`flex w-full items-center whitespace-nowrap ${justify}`}>
      {activeDataToShow?.map((info, idx) => (
        <PromotionLink
          key={idx}
          href={`/${info?.url ?? '#'}`}
          oncePerSession
          promotion={buildPromotion({
            section: PROMOTION_SECTIONS.topBarTicker,

            position: (idx % activeData.length) + 1,
            id: info?.id,
            name: getPromotionName(info, ['title', 'label']),
          })}
          className='inline-flex shrink-0 items-center gap-4 text-xl font-bold max-sm:text-xs'
        >
          <span
            style={{
              background: info?.['title-background-color'],
              color: info?.['title-color'],
            }}
            className='rounded-xl px-2 py-1'
          >
            {info?.[`title-${locale}`]}
          </span>
          <span
            style={{
              background: info?.['label-background-color'],
              color: info?.['label-color'],
            }}
            className='rounded-xl px-2 py-1'
          >
            {info?.[`label-${locale}`]}
          </span>
        </PromotionLink>
      ))}
    </div>
  );

  return (
    <div style={{ background: data?.['section-background-color'] }}>
      <div className='flex h-[42px] items-center sm:h-[45px] md:h-12 lg:h-[51px]'>
        <Marquee
          className={`w-full overflow-y-hidden`}
          style={locale === 'ar' ? { direction: 'ltr' } : {}}
          direction={locale === 'en' ? 'left' : 'right'}
          pauseOnHover
          gradient={false}
          speed={isMobile ? 70 : 130}
        >
          <ItemsRow justify='justify-start gap-10' />
        </Marquee>
      </div>
    </div>
  );
};

export default Alerts;
